import type { PremiseDataDocument } from '../../../interfaces/containers/premises/PremiseData';

export function hasInterruptibleService(
	masterData: PremiseDataDocument | undefined,
): masterData is PremiseDataDocument {
	return Boolean(masterData?.data?.service?.electric?.interruptible);
}
